import styled from 'styled-components';
export const StyledDiv = styled.div`
  background-color  : #eff9fe !important;
  border-top: 3px solid #d2ecfc;
  border-bottom:3px solid #d2ecfc;
  padding: 50px;
`;
